import type { CoverLetterDocumentType } from '@xing-com/crate-lebenslauf-shared-client-document-variable';

import type { EditEducationalInformationFields } from '../types/SharedActions';

import { deserializeName } from './deserializeName';
import { updateLocalStorage } from './updateLocalStorage';

export const editEducationalExperienceFields = (
  doc: CoverLetterDocumentType,
  value: EditEducationalInformationFields['value']
): void => {
  const { name, index } = deserializeName(value.name);
  const educationExperiences = [...(doc.educationExperience ?? [])];

  if (index === undefined) return;

  const educationExperience = educationExperiences[index];

  if (!educationExperience) return;

  // @ts-expect-error FIXME
  educationExperience[name] = value.value;

  updateLocalStorage(`educationExperience`, educationExperiences);
};
